<template>
    <div>
        <transition>
            <!-- Editable -->
            <div v-if="state === 'editable'">
                <div class="uk-card uk-card-default uk-card-small">

                    <header class="uk-card-header">

                        <div class="uk-grid-small" uk-grid>

                            <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                <span class="uk-badge uk-badge-large uk-margin-small-right">1</span>
                                <span>Контактная информация</span>
                            </h2>

                        </div>

                    </header>

                    <div class="uk-card-body">

                        <div class="uk-grid-small uk-child-width-auto uk-flex uk-flex-center" uk-grid>

                            <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                                <input v-model="Customer.is_company" :value="0" id="type-1" class="uk-radio"
                                       type="radio">
                                <label for="type-1">
                                    <div class="tm-choose-title">Физическое лицо</div>
                                </label>
                            </div>

                            <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                                <input v-model="Customer.is_company" :value="1" id="type-2" class="uk-radio"
                                       type="radio">
                                <label for="type-2">
                                    <div class="tm-choose-title">Юридическое лицо</div>
                                </label>
                            </div>

                        </div>
                        <div>
                            <h3 class="uk-text-center">Контактное лицо</h3>

                            <div class="uk-grid-small" uk-grid>


                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">Имя<span
                                            class="uk-text-danger">*</span></label>
                                    <input name="name" v-model="Customer.first_name" class="uk-input"  v-validate="'required|alpha'"
                                           :class="{'uk-form-danger': errors.has('name') }" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">Фамилия <span
                                            class="uk-text-danger"></span></label>
                                    <input v-model="Customer.last_name" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-1">
                                    <label class="uk-form-label">Отчество <span
                                            class="uk-text-danger"></span></label>
                                    <input v-model="Customer.patronymic" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">Телефон<span
                                            class="uk-text-danger">*</span></label>
                                    <div class="uk-flex uk-width-1-1">
                                        <input placeholder=""
                                               name="phone"
                                               v-model="Customer.tel"
                                               v-validate="rules.phone"
                                               v-phone
                                               :class="{'uk-form-danger': errors.has('phone') }"
                                               class="uk-input tm-tel-number" type="tel">
                                    </div>
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">e-mail <span
                                            class="uk-text-danger">*</span></label>
                                    <input v-model="Customer.email" name="email" v-validate="'required|email'"
                                           :class="{'uk-form-danger': errors.has('email') }" class="uk-input" type="text">
                                </div>

                            </div>
                        </div>
                        <div v-if="Customer.is_company === 1">
                            <h3 class="uk-text-center">Реквизиты компании</h3>

                            <div class="uk-grid-small" uk-grid>

                                <div class="uk-width-1-1">
                                    <label class="uk-form-label">Компания <span
                                            class="uk-text-danger"></span></label>
                                    <input v-model="Customer.company" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">ИНН <span class="uk-text-danger"></span></label>
                                    <input v-model="Customer.tin" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">КПП <span class="uk-text-danger"></span></label>
                                    <input v-model="Customer.trrc" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-1">
                                    <label class="uk-form-label">Юридический адрес</label>
                                    <input v-model="Customer.legal_address" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">Название банка</label>
                                    <input v-model="Customer.bank" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">БИК</label>
                                    <input v-model="Customer.bic" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">р/c</label>
                                    <input v-model="Customer.bank_account" class="uk-input" type="text">
                                </div>

                                <div class="uk-width-1-2">
                                    <label class="uk-form-label">к/с</label>
                                    <input v-model="Customer.correspondent_account" class="uk-input" type="text">
                                </div>

                            </div>
                        </div>

                        <div class="uk-text-center uk-margin-medium">
                            <button @click.prevent="validateAndNext()" class="uk-button uk-button-secondary">
                                <span>Далее</span>
                                <span class="uk-margin-small-left uk-icon" uk-icon="icon: arrow-right"></span>
                            </button>
                        </div>

                    </div>

                </div>
            </div>

            <!-- Ready -->
            <div v-if="state === 'completed'">
                <div class="uk-card uk-card-default uk-card-small">

                    <header class="uk-card-header">

                        <div class="uk-grid-small" uk-grid>

                            <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                            <span class="uk-badge uk-badge-large uk-margin-small-right cart-badge-success">
                                                <span class="uk-icon" uk-icon="icon: check"></span>
                                            </span>
                                <span class="uk-text-muted">Контактная информация</span>
                            </h2>

                            <div class="uk-width-auto uk-flex uk-flex-middle">
                                <a @click.prevent="$emit('cart::editStep')" class="uk-link-muted">
                                    <span class="uk-icon" uk-icon="icon: pencil"></span>
                                    <span>Редактировать</span>
                                </a>
                            </div>

                        </div>

                    </header>

                    <div class="uk-card-body">

                        <div class="uk-grid-small uk-text-small uk-text-muted" uk-grid>

                            <div class="uk-width-1-3">
                                <dl class="uk-description-list">

                                    <dt>Клиент</dt>
                                    <dd v-if="Customer.is_company === 1">Компания</dd>
                                    <dd v-else>Физическое лицо</dd>

                                </dl>
                            </div>

                            <div v-if="Customer.is_company === 1" class="uk-width-1-3">
                                <dl class="uk-description-list">

                                    <dt>ИНН</dt>
                                    <dd>{{ Customer.tin }}</dd>

                                    <dt>КПП</dt>
                                    <dd>{{ Customer.trrc }}</dd>

                                    <dt>Юридический адрес</dt>
                                    <dd>{{ Customer.legal_address }}</dd>

                                    <dt>Банк</dt>
                                    <dd>{{ Customer.bank }}</dd>

                                    <dt>БИК</dt>
                                    <dd>{{ Customer.bic }}</dd>

                                    <dt>р/с</dt>
                                    <dd>{{ Customer.bank_account }}</dd>

                                    <dt>к/с</dt>
                                    <dd>{{ Customer.correspondent_account }}</dd>

                                </dl>
                            </div>

                            <div class="uk-width-1-3">
                                <dl class="uk-description-list">

                                    <dt>Контактное лицо</dt>
                                    <dd>{{ Customer.last_name }} {{ Customer.first_name }} {{ Customer.patronymic }}</dd>

                                    <dt>Телефон</dt>
                                    <dd>{{ Customer.phone }}</dd>

                                    <dt>e-mail</dt>
                                    <dd>{{ Customer.email }}</dd>

                                </dl>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            state: {
                'type': String,
                'required': true,
                'default': 'editable'
            },
            data: {
                'type': Object,
                'required': true,
                'default': {}
            },
        },
        data(){
            return {
                Customer: this.data.ShopCustomer,
                rules: {
                    // phone: {required: true, regex: /[7-9]{2}\d{8}/}
                    phone: {required: true, regex: /^([0-9\s\-\+\(\)]{7,})$/ }
                }
            }
        },
        mounted(){
            this.$emit('update:data', {ShopCustomer: this.Customer});
        },
        methods: {
            validateAndNext(){
                this.Customer.phone = this.Customer.tel;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('cart::nextStep');
                    }
                })
            }
        },
}
</script>



// WEBPACK FOOTER //
// CartContact.vue?f3663eb8